module.exports = __webpack_public_path__ + "19d9d5a672b2df9ef3103efd99cbe690.svg";